import { getUserData } from "@/auth/getUserData";
import { ref, readonly } from "@vue/composition-api";

const profilePicture = ref(null);

export default function useUserConfig() {
    if (!profilePicture.value) {
        profilePicture.value = getUserData()?.pictureUrl;
    }

    const setUserSetting = (name, val) => {
        const settingIndex = getUserData().settings.findIndex((setting) => setting.name === name);

        // Setting not found, return, because then we can use the default fallback.
        if (settingIndex === -1) {
            return;
        }

        const userData = getUserData();

        userData.settings[settingIndex].value = val;

        localStorage.setItem("userData", JSON.stringify(userData));
    };

    const getUserSetting = (name, defaultValue) => {
        if (!getUserData()) {
            return defaultValue;
        }

        if (localStorage.getItem(name)) {
            return localStorage.getItem(name);
        }

        return getUserData()?.settings?.find((setting) => setting.name === name)?.value ?? defaultValue;
    };

    const setProfilePicture = (url) => {
        profilePicture.value = url;
        // update localstorage as well
        const userData = getUserData();
        userData.pictureUrl = url;
        localStorage.setItem("userData", JSON.stringify(userData));
    };

    return {
        profilePicture: readonly(profilePicture),

        getUserSetting,
        setUserSetting,
        setProfilePicture,
    };
}
